export default __webpack_public_path__ + "static/media/icon-share-list.df00fdae.svg";